import "bootstrap/dist/css/bootstrap.min.css";
import "./Css/main.css";
import PageWrap from "./View/PageWrap";

import {
  subUrl,
  manualdownload,
  clientNewsDetail,
  clientNewsDocument,
  clientHome,
} from "./Api/SubUrl";

import {
  ClntPage,
  ClntHome,
  ClnDownloadGame,
  ClnNewDetail,
  ClnNewDocument,
} from "./View/Client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // Import file CSS của "aos"
import "rsuite/dist/rsuite.min.css";

// Khởi tạo "aos" với các tùy chọn (nếu cần)
AOS.init({
  duration: 1000, // Thời gian thực hiện hiệu ứng (mặc định là 1000ms)
  easing: "ease-in-out", // Kiểu easing (mặc định là 'ease')
});

function App() {
  AOS.init();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageWrap />}>
          <Route path={subUrl} element={<ClntPage />}>
            <Route path={subUrl} element={<ClntHome />} />
            <Route path={clientHome} element={<ClntHome />} />
            <Route path={clientNewsDocument} element={<ClnNewDocument />} />
            <Route path={clientNewsDetail} element={<ClnNewDetail />} />
            <Route path={manualdownload} element={<ClnDownloadGame />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
